import { render, staticRenderFns } from "./AiMergedText.vue?vue&type=template&id=66637461&scoped=true"
import script from "./AiMergedText.vue?vue&type=script&lang=js"
export * from "./AiMergedText.vue?vue&type=script&lang=js"
import style0 from "./AiMergedText.vue?vue&type=style&index=0&id=66637461&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66637461",
  null
  
)

export default component.exports